import logo from 'assets/header-prevencor-xx.png';
import AssinaturaEletronica from 'components/core/AssinaturaEletronica';
import LaudoActionButtons from 'components/laudos/LaudoActionButtons';
import { Card, Form, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { selectTransById } from 'services/trans';
import useSWR from 'swr';
import { generatePDFTrans } from './gerarPDFTrans';

function MultiLineSection({ title, value }) {
  const text = String(value ?? '').trim();

  return (
    <Form.Group>
      <u className="mr-auto">{title}</u>
      {text ? (
        text.split('\n').map((linha, index) => (
          <div key={`trans-descricao-${index}`} className="row">
            <div className="col-12">{linha}</div>
          </div>
        ))
      ) : (
        <div className="text-muted">Sem descrição preenchida.</div>
      )}
    </Form.Group>
  );
}

export default function ReportTrans() {
  const { id } = useParams();
  const {
    data: trans,
    isLoading,
    error,
  } = useSWR(id ? ['trans', id] : null, () => selectTransById(id));

  const textoLaudo = trans?.ECOTRANS;

  return (
    <Card className="mb-2 mt-2">
      <Card.Header className="text-center font-weight-bold">
        <img
          src={logo}
          alt="Prevencor"
          style={{ display: 'block', maxWidth: '100%', margin: '0 auto 8px' }}
          className="no-print"
        />
        LAUDO DE ECO TRANSESOFÁGICO
      </Card.Header>

      {isLoading && (
        <Card.Body>
          <div className="d-flex justify-content-center align-items-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Card.Body>
      )}

      {error && !isLoading && (
        <Card.Body className="text-center text-danger py-5">
          {error.message || 'Erro ao carregar o laudo.'}
        </Card.Body>
      )}

      {!isLoading && !error && !trans && (
        <Card.Body className="text-muted text-center py-5">Laudo não encontrado.</Card.Body>
      )}

      {trans && !isLoading && !error && (
        <>
          <Card.Body>
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${trans.CODPAC || '--'} - ${trans.NOMEPAC || '--'}`}
            <br />
            <strong className="mr-auto">Data de Nasc: </strong>
            {trans.dataNasc || '--'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Sexo: </strong>
            {trans.SEXOPAC || '--'}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {trans.idadePAC ? `${trans.idadePAC} anos` : '--'}
            <br />
            <strong className="mr-auto">Convênio: </strong>
            {trans.SIGLACONV || '--'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Código: </strong>
            {trans.CODTRANS || trans.CODIGO || '--'}&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {trans.dataTrans || trans.dataFormatada || '--'}
            <br />
            <strong className="mr-auto">Médico que Realizou: Dr. </strong>
            {trans.Realizou || '--'}
            <br />
            <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
            {trans.Solicitou || '--'}
            <hr />
            <MultiLineSection title="Descrição:" value={textoLaudo} />
          </Card.Body>

          <Card.Footer className="text-center no-print">
            <LaudoActionButtons
              actions={[
                {
                  key: 'timbrado',
                  label: 'Timbrado',
                  onClick: () => generatePDFTrans({ trans }),
                },
              ]}
            />
          </Card.Footer>

          <Card.Footer className="text-center">
            <AssinaturaEletronica data={trans} nome={trans.Realizou} showPrintButton={false} />
          </Card.Footer>
        </>
      )}
    </Card>
  );
}
